var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Oi oi! It ain't here, that what ya looking for! You may try again, go ahead... Try again! ")])}
var staticRenderFns = []

export { render, staticRenderFns }